import {ActionService, ConfigurationService, JwtHttpClientService, ResourceModule} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";


/**
 * Action Service to void a sale cashout
 */
@Injectable()
export class SalesJournalVoidCashoutService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "sales-journal-void-cashout");
    }
}
